export default [
    {
        path: '/website/cache',
        props: true,
        component: () => import('@/views/WebsiteCache'),
    },
];
